import { Action } from '@ngrx/store';
import { Timeline, TimelineInfoMessage } from './timeline.models';

export enum TimelineActionTypes {
  INFO_MESSAGE_DONE = '[TimelineAction] Info message done',
  INFO_MESSAGE_DONE_FAILED = '[TimelineAction] Info message done failed',
  INFO_MESSAGE_DONE_SUCCESS = '[TimelineAction] Info message done success',
  LOAD_TIMELINE = '[TimelineAction] Load timeline',
  LOAD_TIMELINE_FAILED = '[TimelineAction] Load timeline failed',
  LOAD_TIMELINE_SUCCESS = '[TimelineAction] Load timeline success',
  CHECK_AND_SCHEDULE_NOTIFICATION = '[TimelineAction] Check and schedule notification'
}

export class TimelineActionInfoMessageDone implements Action {
  readonly type = TimelineActionTypes.INFO_MESSAGE_DONE;

  constructor(public payload: TimelineInfoMessage) {}
}

export class TimelineActionInfoMessageDoneFailed implements Action {
  readonly type = TimelineActionTypes.INFO_MESSAGE_DONE_FAILED;

  constructor(public payload: TimelineInfoMessage) {}
}

export class TimelineActionInfoMessageDoneSuccess implements Action {
  readonly type = TimelineActionTypes.INFO_MESSAGE_DONE_SUCCESS;

  constructor(public payload: TimelineInfoMessage) {}
}

export class TimelineActionLoadTimeline implements Action {
  readonly type = TimelineActionTypes.LOAD_TIMELINE;
}

export class TimelineActionLoadTimelineFailed implements Action {
  readonly type = TimelineActionTypes.LOAD_TIMELINE_FAILED;
}

export class TimelineActionLoadTimelineSuccess implements Action {
  readonly type = TimelineActionTypes.LOAD_TIMELINE_SUCCESS;

  constructor(public payload: Timeline) {}
}

export class TimelineActionCheckAndScheduleNotification implements Action {
  readonly type = TimelineActionTypes.CHECK_AND_SCHEDULE_NOTIFICATION;

  constructor(public payload: Timeline) {}
}

export type TimelineActions =
  | TimelineActionInfoMessageDone
  | TimelineActionInfoMessageDoneFailed
  | TimelineActionInfoMessageDoneSuccess
  | TimelineActionLoadTimeline
  | TimelineActionLoadTimelineFailed
  | TimelineActionLoadTimelineSuccess
  | TimelineActionCheckAndScheduleNotification;
